"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = listenImgErrorByFmp;

var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getImgForFmp = _interopRequireDefault(require("./getImgForFmp"));

/**
 * @file 图片加载失败监控
 * @author zhangyanting
 */
var PERCENT_FAILIMG_COUNT_IN_FMP = 0.4; // 加载失败图片占比阀值

/**
 * @file 监听首屏图片是否异常
 * @author zhangyanting
 */

function listenImgErrorByFmp(domContainer, callback) {
  if (!('MutationObserver' in window)) {
    return;
  }

  var domObserver = new MutationObserver(function () {
    var _context;

    var imgs = (0, _getImgForFmp.default)(document.body).imgDoms;
    var imgsArray = (0, _from.default)(imgs);
    var fmpImgCount = imgsArray.length;
    var loadedFailImgCount = 0;
    var isExceptSended = false;
    (0, _forEach.default)(_context = (0, _from.default)(imgs)).call(_context, function (imgItem) {
      imgItem.onerror = function (e) {
        loadedFailImgCount++;

        if ( // 加载失败的图片比例 超过首屏图片的阀值
        loadedFailImgCount >= Math.ceil(fmpImgCount * PERCENT_FAILIMG_COUNT_IN_FMP) && !isExceptSended) {
          isExceptSended = true;
          domObserver.disconnect();
          callback && callback(loadedFailImgCount);
        }
      };
    });
  });
  domObserver.observe(domContainer, {
    childList: true,
    subtree: true,
    attributes: true
  });
}